[
  {
    "draftJersey": 8,
    "role": "DF",
    "name": "Aleix Hernando",
    "foot": "right",
    "height": 170,
    "birthdate": "15/10/2003",
    "country": "España",
    "macros": {
      "physical": 73,
      "duels": 69,
      "shooting": 66,
      "defence": 81,
      "passing": 72,
      "skills": 68,
      "average": 73
    },
    "matchYtVideoId": "-K5grbzs_Tg",
    "profileYtVideoId": "4YIMtMf4jio",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/520784735.png"
  },
  {
    "draftJersey": 21,
    "role": "MC",
    "name": "Ñito Martín",
    "foot": "right",
    "height": 179,
    "birthdate": "25/01/1993",
    "country": "España",
    "macros": {
      "physical": 74,
      "duels": 67,
      "shooting": 76,
      "defence": 70,
      "passing": 73,
      "skills": 64,
      "average": 71
    },
    "matchYtVideoId": "-K5grbzs_Tg",
    "profileYtVideoId": "w52qaUp0c_I",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/679257725.png"
  },
  {
    "draftJersey": 22,
    "role": "MC",
    "name": "Isaac Serna ",
    "foot": "right",
    "height": 179,
    "birthdate": "05/07/1997",
    "country": "España",
    "macros": {
      "physical": 71,
      "duels": 74,
      "shooting": 71,
      "defence": 75,
      "passing": 70,
      "skills": 77,
      "average": 73
    },
    "matchYtVideoId": "y01vps9Imog",
    "profileYtVideoId": "4btWQ7Fn3Zg",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/574916638.png"
  },
  {
    "draftJersey": 38,
    "role": "MC",
    "name": "Alex Domingo",
    "foot": "right",
    "height": 169,
    "birthdate": "25/05/2001",
    "country": "España",
    "macros": {
      "physical": 77,
      "duels": 61,
      "shooting": 66,
      "defence": 75,
      "passing": 81,
      "skills": 58,
      "average": 70
    },
    "matchYtVideoId": "PhbZO3ABZI8",
    "profileYtVideoId": "-AEGXJnK3zg",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/867576211.png"
  },
  {
    "draftJersey": 44,
    "role": "MC",
    "name": "Aozora Kishimoto",
    "foot": "right",
    "height": 171,
    "birthdate": "30/05/1995",
    "country": "Japón",
    "macros": {
      "physical": 83,
      "duels": 79,
      "shooting": 83,
      "defence": 79,
      "passing": 83,
      "skills": 81,
      "average": 81
    },
    "matchYtVideoId": "a283pWCxBxg",
    "profileYtVideoId": "bnOBpqHYN1g",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/163618250.png"
  },
  {
    "draftJersey": 48,
    "role": "MC",
    "name": "Daniel Plaza",
    "foot": "left",
    "height": 170,
    "birthdate": "19/09/2003",
    "country": "España",
    "macros": {
      "physical": 69,
      "duels": 85,
      "shooting": 86,
      "defence": 78,
      "passing": 85,
      "skills": 83,
      "average": 82
    },
    "matchYtVideoId": "y01vps9Imog",
    "profileYtVideoId": "AYZu5o0wEZ8",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/76293929.png"
  },
  {
    "draftJersey": 54,
    "role": "MC",
    "name": "David Campos",
    "foot": "right",
    "height": 177,
    "birthdate": "29/06/2005",
    "country": "España",
    "macros": {
      "physical": 70,
      "duels": 78,
      "shooting": 65,
      "defence": 75,
      "passing": 71,
      "skills": 77,
      "average": 72
    },
    "matchYtVideoId": "y01vps9Imog",
    "profileYtVideoId": "hZimwMr87DA",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/11019495.png"
  },
  {
    "draftJersey": 56,
    "role": "DF",
    "name": "Izan Espinosa",
    "foot": "right",
    "height": 182,
    "birthdate": "24/10/2000",
    "country": "España",
    "macros": {
      "physical": 73,
      "duels": 74,
      "shooting": 68,
      "defence": 63,
      "passing": 78,
      "skills": 71,
      "average": 70
    },
    "matchYtVideoId": "h7n8Nv-ybvA",
    "profileYtVideoId": "JHF-In4lblM",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/938934408.png"
  },
  {
    "draftJersey": 79,
    "role": "DL",
    "name": "Juan Pedro Nzo",
    "foot": "left",
    "height": 179,
    "birthdate": "04/04/1997",
    "country": "Guinea Ecuatoriana",
    "macros": {
      "physical": 77,
      "duels": 78,
      "shooting": 83,
      "defence": 69,
      "passing": 79,
      "skills": 86,
      "average": 80
    },
    "matchYtVideoId": "T6TQBnedUyQ",
    "profileYtVideoId": "wO1mVDJTUQM",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/712562639.png"
  },
  {
    "draftJersey": 82,
    "role": "DL",
    "name": "Marc Pilar",
    "foot": "right",
    "height": 177,
    "birthdate": "27/07/1998",
    "country": "España",
    "macros": {
      "physical": 76,
      "duels": 79,
      "shooting": 84,
      "defence": 72,
      "passing": 79,
      "skills": 83,
      "average": 80
    },
    "matchYtVideoId": "5sz9_1CvhWw",
    "profileYtVideoId": "GEHXYgyOpD0",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/58166186.png"
  },
  {
    "draftJersey": 86,
    "role": "MC",
    "name": "Joel Ruz",
    "foot": "right",
    "height": 172,
    "birthdate": "14/12/2001",
    "country": "España",
    "macros": {
      "physical": 68,
      "duels": 73,
      "shooting": 68,
      "defence": 63,
      "passing": 78,
      "skills": 81,
      "average": 72
    },
    "matchYtVideoId": "h7n8Nv-ybvA",
    "profileYtVideoId": "4DzN20DZDp0",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/583076172.png"
  },
  {
    "draftJersey": 89,
    "role": "DF",
    "name": "Lucas Palma",
    "foot": "right",
    "height": 184,
    "birthdate": "12/12/1996",
    "country": "España",
    "macros": {
      "physical": 70,
      "duels": 72,
      "shooting": 64,
      "defence": 73,
      "passing": 71,
      "skills": 73,
      "average": 71
    },
    "matchYtVideoId": "y01vps9Imog",
    "profileYtVideoId": "a9hGPRx1b2o",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/98721089.png"
  },
  {
    "draftJersey": 92,
    "role": "MC",
    "name": "Juan Manuel Fernández",
    "foot": "right",
    "height": 169,
    "birthdate": "18/01/1993",
    "country": "Uruguay",
    "macros": {
      "physical": 72,
      "duels": 72,
      "shooting": 72,
      "defence": 61,
      "passing": 81,
      "skills": 66,
      "average": 71
    },
    "matchYtVideoId": "T6TQBnedUyQ",
    "profileYtVideoId": "tu_SnuRbE4I",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/221915419.png"
  },
  {
    "draftJersey": 96,
    "role": "MC",
    "name": "Manuel Linares",
    "foot": "right",
    "height": 170,
    "birthdate": "10/02/2004",
    "country": "España",
    "macros": {
      "physical": 72,
      "duels": 79,
      "shooting": 72,
      "defence": 63,
      "passing": 78,
      "skills": 73,
      "average": 73
    },
    "matchYtVideoId": "T6TQBnedUyQ",
    "profileYtVideoId": "oo4yLmzqaQY",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/315109075.png"
  },
  {
    "draftJersey": 102,
    "role": "DF",
    "name": "Cristian Faura",
    "foot": "left",
    "height": 178,
    "birthdate": "07/01/1992",
    "country": "España",
    "macros": {
      "physical": 72,
      "duels": 76,
      "shooting": 74,
      "defence": 76,
      "passing": 79,
      "skills": 82,
      "average": 76
    },
    "matchYtVideoId": "PhbZO3ABZI8",
    "profileYtVideoId": "BZxV7OqVSec",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/249773060.png"
  },
  {
    "draftJersey": 106,
    "role": "DF",
    "name": "Genís Martínez",
    "foot": "right",
    "height": 181,
    "birthdate": "04/05/2005",
    "country": "España",
    "macros": {
      "physical": 79,
      "duels": 66,
      "shooting": 58,
      "defence": 79,
      "passing": 64,
      "skills": 62,
      "average": 71
    },
    "matchYtVideoId": "a283pWCxBxg",
    "profileYtVideoId": "Hy_ogmuHEC4",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/250859341.png"
  },
  {
    "draftJersey": 117,
    "role": "DL",
    "name": "Eric Lobato",
    "foot": "right",
    "height": 175,
    "birthdate": "20/04/2000",
    "country": "España",
    "macros": {
      "physical": 71,
      "duels": 87,
      "shooting": 88,
      "defence": 76,
      "passing": 89,
      "skills": 87,
      "average": 84
    },
    "matchYtVideoId": "PhbZO3ABZI8",
    "profileYtVideoId": "-BclhoBmmWk",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/553310453.png"
  },
  {
    "draftJersey": 119,
    "role": "DL",
    "name": "Fran Rodríguez",
    "foot": "left",
    "height": 170,
    "birthdate": "19/11/2003",
    "country": "España",
    "macros": {
      "physical": 74,
      "duels": 79,
      "shooting": 73,
      "defence": 64,
      "passing": 79,
      "skills": 79,
      "average": 75
    },
    "matchYtVideoId": "-K5grbzs_Tg",
    "profileYtVideoId": "CO5uhteU4Q8",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/180342803.png"
  },
  {
    "draftJersey": 149,
    "role": "DF",
    "name": "Stelios Orgianos",
    "foot": "right",
    "height": 183,
    "birthdate": "21/08/2001",
    "country": "Suiza",
    "macros": {
      "physical": 72,
      "duels": 73,
      "shooting": 68,
      "defence": 70,
      "passing": 77,
      "skills": 66,
      "average": 71
    },
    "matchYtVideoId": "9mNB0j37rzc",
    "profileYtVideoId": "4MO32aAjFyQ",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/217386279.png"
  },
  {
    "draftJersey": 161,
    "role": "DL",
    "name": "Mario Rodríguez",
    "foot": "left",
    "height": 170,
    "birthdate": "24/10/2001",
    "country": "España",
    "macros": {
      "physical": 79,
      "duels": 76,
      "shooting": 73,
      "defence": 78,
      "passing": 78,
      "skills": 83,
      "average": 77
    },
    "matchYtVideoId": "h7n8Nv-ybvA",
    "profileYtVideoId": "666LnhAGMGk",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/387881614.png"
  },
  {
    "draftJersey": 181,
    "role": "MC",
    "name": "Miraash Imthiyaz",
    "foot": "right",
    "height": 175,
    "birthdate": "11/10/1999",
    "country": "Maldivas",
    "macros": {
      "physical": 73,
      "duels": 84,
      "shooting": 86,
      "defence": 75,
      "passing": 84,
      "skills": 85,
      "average": 82
    },
    "matchYtVideoId": "h7n8Nv-ybvA",
    "profileYtVideoId": "vT0_Diqb_Z0",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/343784100.png"
  },
  {
    "draftJersey": 194,
    "role": "MC",
    "name": "Xabi Apalategi",
    "foot": "right",
    "height": 178,
    "birthdate": "09/07/1998",
    "country": "España",
    "macros": {
      "physical": 74,
      "duels": 77,
      "shooting": 73,
      "defence": 75,
      "passing": 79,
      "skills": 83,
      "average": 77
    },
    "matchYtVideoId": "5sz9_1CvhWw",
    "profileYtVideoId": "xHHC8BJdqEw",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/880539749.png"
  },
  {
    "draftJersey": 301,
    "role": "DL",
    "name": "Alex Medina",
    "foot": "right",
    "height": 179,
    "birthdate": "10/04/2003",
    "country": "España",
    "macros": {
      "physical": 73,
      "duels": 83,
      "shooting": 80,
      "defence": 81,
      "passing": 84,
      "skills": 84,
      "average": 81
    },
    "matchYtVideoId": "AMDaNAf7-aM",
    "profileYtVideoId": "IBbtOYM8-3g",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/994445525.png"
  },
  {
    "draftJersey": 303,
    "role": "DL",
    "name": "Diego Jiménez",
    "foot": "right",
    "height": 181,
    "birthdate": "17/10/2001",
    "country": "España",
    "macros": {
      "physical": 72,
      "duels": 80,
      "shooting": 83,
      "defence": 78,
      "passing": 85,
      "skills": 84,
      "average": 81
    },
    "matchYtVideoId": "AMDaNAf7-aM",
    "profileYtVideoId": "vNQvhx8h2Ls",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/975657054.png"
  },
  {
    "draftJersey": 344,
    "role": "DL",
    "name": "Nauzet Hernández",
    "foot": "right",
    "height": 166,
    "birthdate": "24/11/2001",
    "country": "España",
    "macros": {
      "physical": 70,
      "duels": 89,
      "shooting": 84,
      "defence": 74,
      "passing": 83,
      "skills": 89,
      "average": 83
    },
    "matchYtVideoId": "AMDaNAf7-aM",
    "profileYtVideoId": "CBDOhxnBuqc",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/533815430.png"
  }
]